module.exports = __webpack_public_path__ + "static/img/ic_x_s.69afbbc1.svg";